import allSettled from 'promise.allsettled';
allSettled.shim();

require('./app');
